// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"45a689c1","23":"e853023f","220":"4e859e0d","230":"d95ab49a","288":"a3a9eaeb","351":"2dc9ce68","374":"cad0c3fb","436":"5c508d50","569":"f55d4847","907":"0f96bd86"}[chunkId] + ".chunk.js";
};